import { createContext } from 'react';

import { noop } from '@app/utils/noop';

import { TableColumn, TableFilter, TableSortValue, TablePagination } from '../types';

export interface QueryTableContextValue<I extends EntityBase = EntityBase> {
  filter: TableFilter<I>[];
  setFilter(value: TableFilter<I>[]): void;
  sort: TableSortValue<I>;
  setSort(value: TableSortValue<I>): void;
  pagination: TablePagination;
  setPagination(value: TablePagination): void;
  columns: TableColumn<I>[];
  data: I[];
  loading: boolean;
  refetch(): void;
  setData(data: I[]): void;
}

export const QueryTableContext = createContext<QueryTableContextValue<EntityBase>>({
  filter: [],
  setFilter: noop,
  sort: { name: 'id', direction: 'asc' },
  setSort: noop,
  pagination: { page: 1, pageSize: 10 },
  setPagination: noop,
  columns: [],
  data: [],
  loading: false,
  refetch: noop,
  setData: noop,
});